$(document.body).on('click', 'ul.uk-pagination li a', function(e) {
    event.preventDefault();
    //console.log($(this).data('page'));
    $("#filter :input[name='page']").val($(this).data('page'));
    $("#filter").trigger("change");
    $("#filter :input[name='page']").val("1");

});